export const REVIEW_DOCS = [
    {
        v: 0, c: 0, pid: 'rar_0', rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], title: false,
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Anteproyecto de intervención en BIENES DE INTERÉS CULTURAL (BIC) o en inmuebles colindantes o localizados dentro de su área de influencia', }
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_1', rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], title: 'Rótulo',
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Dirección', },
            { v: 2, c: 2, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Firma del arquitecto responsable (indispensable validez)', },
            { v: 3, c: 3, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Número de matricula del arquitecto', },
            { v: 4, c: 4, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Escala', },
            { v: 5, c: 5, rtype: ['sub', 'col',], name: 'Nombre del Predio', },
            { v: 6, c: 6, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Propietario', },
            { v: 7, c: 7, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Tipo de tramite', },
            { v: 8, c: 8, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Contenido del Plano', },
            { v: 9, c: 9, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Numeración del plano', },
            { v: 10, c: 10, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Fecha', },
            { v: 11, c: 11, rtype: ['con', 'col', 'cre',], name: 'Firma del diseñador de elementos no estructurales según A.1.5.2.2', },
            { v: 12, c: 12, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Todos los planos arquitectónicos deben incluir una nota visible que contenga el Grupo de Uso según A.2.5 del Reglamento NSR-10 (I, II, III o IV)', },
            { v: 13, c: 13, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Grado de Desempeño de los elementos no estructurales (Superior, Bueno o Bajo) que se requiere para el grupo de uso de la edificación según A.9.2 del Reglamento NSR-10', },
            { v: 14, c: 14, rtype: ['cre'], name: 'Código Catastral /matricula inmobiliaria', },
            { v: 15, c: 15, rtype: ['cre'], name: 'Propietario', },
            { v: 16, c: 16, rtype: ['cre'], name: 'Tipo de tramite', },
            { v: 17, c: 17, rtype: ['cre'], name: 'Contenido del Plano', },
            { v: 18, c: 18, rtype: ['cre'], name: 'Numeración del plano', },
            { v: 19, c: 19, rtype: ['cre'], name: 'Fecha', },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_2', rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], title: 'Características del predio ',
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Plano de localización e identificación (georreferenciado)', },
            { v: 2, c: 2, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Sección vial', },
            { v: 3, c: 3, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Nomenclatura vial', },
            { v: 4, c: 4, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Linderos del predio', },
            { v: 5, c: 5, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Norte', },
            { v: 6, c: 6, rtype: ['con', 'cer', 'ph', 'col',], name: 'Coincide la escala con el dibujo', },
            { v: 7, c: 7, rtype: ['con', 'col',], name: 'Retroceso y/o aislamientos', },
            { v: 8, c: 8, rtype: ['con', 'col',], name: 'Visto bueno de la copropiedad', },
            { v: 9, c: 9, rtype: ['sub', 'cer', 'col',], name: 'Punto de referencia (Contexto)', },
            { v: 10, c: 10, rtype: ['sub', 'cer', 'col',], name: 'Localización general', },
            { v: 11, c: 11, rtype: ['con', 'sub', 'cer', 'col',], name: 'Ubicación de la edificación según urbanismo/RPH', },

        ]
    },
    {
        v: 0, c: 0, pid: 'rar_3', rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], title: 'Cuadro de Áreas',
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Cuadro general de las áreas del proyecto arquitectónico', },
            { v: 2, c: 2, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Área de lote', },
            { v: 3, c: 3, rtype: ['con', 'ph', 'col',], name: 'Área construida por piso', },
            { v: 4, c: 4, rtype: ['con', 'col',], name: 'Retrocesos', },
            { v: 5, c: 5, rtype: ['sub', 'col',], name: 'Indices', },
            { v: 6, c: 6, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Coincidencia con la escritura', hide: true },
            { v: 7, c: 7, rtype: ['sub', 'cer', 'col',], name: 'Area lote mayor extensión ', },
            { v: 8, c: 8, rtype: ['sub', 'col',], name: 'Area lotes resultantes', },
            { v: 9, c: 9, rtype: ['sub', 'col',], name: 'Area de servidumbre', hide: true },
            { v: 10, c: 10, rtype: ['cer',], name: 'Metros lineales del cerramiento', },
            { v: 11, c: 11, rtype: ['cer',], name: 'Area del cerramiento', },
            { v: 12, c: 12, rtype: ['ph',], name: 'Areas comunes construidas por piso', },
            { v: 13, c: 13, rtype: ['ph',], name: 'Areas comunes libres por piso', },
            { v: 14, c: 14, rtype: ['ph',], name: 'Areas privadas construidas por piso', },
            { v: 15, c: 15, rtype: ['ph',], name: 'Areas privadas libres por piso', },
            { v: 16, c: 16, rtype: ['ph',], name: 'NOTA TÉCNICA: Las fachadas, estructura, cubierta y el lote de terreno son bienes comunes', },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_4', rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], title: 'Plantas',
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Primera planta relacionada con el espacio público', },
            { v: 2, c: 2, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Cotas totales y parciales del proyecto', },
            { v: 3, c: 3, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Ejes y elementos estructurales proyectados (sistema estructural)', },
            { v: 4, c: 4, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Niveles', },
            { v: 5, c: 5, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Usos', },
            { v: 6, c: 6, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Indicación cortes (longitudinal, transversal relacionad con e.público)', },
            { v: 7, c: 7, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Planta de cubierta', },
            { v: 8, c: 8, rtype: ['con', 'ph', 'col',], name: 'Estructura', },
            { v: 9, c: 9, rtype: ['con', 'sub', 'ph', 'col',], name: 'Coincide la escala con el dibujo', },
            { v: 10, c: 10, rtype: ['con', 'ph', 'col',], name: 'Planta de todos los niveles', },
            { v: 11, c: 11, rtype: ['con', 'col',], name: 'Iluminación y ventilación de los espacios (obra nueva)', },
            { v: 12, c: 12, rtype: ['con', 'col',], name: 'Voladizo', },
            { v: 13, c: 13, rtype: ['con', 'col',], name: 'Aislamiento posterior', },
            { v: 14, c: 14, rtype: ['con', 'col',], name: 'Antejardin', },
            { v: 15, c: 15, rtype: ['con', 'col',], name: 'Aislamientos laterales', },
            { v: 16, c: 16, rtype: ['con', 'col',], name: 'Cotas totales', },
            { v: 17, c: 17, rtype: ['con', 'col',], name: 'Cotas parciales', },
            { v: 18, c: 18, rtype: ['con', 'col',], name: 'Coincidencia con proyecto estructural', },
            { v: 19, c: 19, rtype: ['con', 'col',], name: 'Señalización de cortes', },
            { v: 20, c: 20, rtype: ['con', 'col',], name: 'Señalización de proyecciones', },
            { v: 21, c: 21, rtype: ['con', 'col',], name: 'Ruta de evacuación', },
            { v: 22, c: 22, rtype: ['con', 'col',], name: 'Accesibilidad', },
            { v: 23, c: 23, rtype: ['con', 'col',], name: 'Escaleras, ancho, huella, contrahuella, pasamanos y detalle', },
            { v: 24, c: 24, rtype: ['con', 'col',], name: 'Parqueaderos', },
            { v: 25, c: 25, rtype: ['con', 'col',], name: 'Coincide con el reglamento de copropiedad', },
            { v: 26, c: 26, rtype: ['con', 'col',], name: 'Cuarto de basuras en multifamiliar', },
            { v: 27, c: 27, rtype: ['con', 'col',], name: 'Instrumentación antisismica', },
            { v: 28, c: 28, rtype: ['con', 'col',], name: 'Aislamiento antisismico', },
            { v: 29, c: 29, rtype: ['con', 'col',], name: 'Wc (comerciales 1.80*1.90)', },
            { v: 30, c: 30, rtype: ['con', 'col',], name: 'Pasillos (institucionales y salud)', },
            { v: 31, c: 31, rtype: ['con', 'col',], name: 'Planta rociadores (uso distinto a residencial)', },
            { v: 32, c: 32, rtype: ['sub', 'col',], name: 'Via de acceso', },
            { v: 33, c: 33, rtype: ['sub', 'col',], name: 'Plano del predio de mayor extensión', },
            { v: 34, c: 34, rtype: ['sub', 'col',], name: 'Area del lote original', },
            { v: 35, c: 35, rtype: ['sub', 'col',], name: 'Plano de los predio subdivididos', },
            { v: 36, c: 36, rtype: ['sub', 'col',], name: 'Linderos de cada lote', },
            { v: 37, c: 37, rtype: ['sub', 'col',], name: 'Area de las subdivisiones ', },
            { v: 38, c: 38, rtype: ['sub', 'col',], name: 'Número predial ', },
            { v: 39, c: 39, rtype: ['sub', 'col',], name: 'Número de matricula ', },
            { v: 40, c: 40, rtype: ['sub', 'col',], name: 'Plano del predio de mayor extensión', hide: true },
            { v: 41, c: 41, rtype: ['cer',], name: 'Predio a escala', },
            { v: 42, c: 42, rtype: ['cer',], name: 'Detalle estructural', },
            { v: 43, c: 43, rtype: ['cer',], name: 'Alturas', },
            { v: 44, c: 44, rtype: ['cer',], name: 'Materiales', },
            { v: 45, c: 45, rtype: ['cer',], name: 'Cotas verticales', },
            { v: 46, c: 46, rtype: ['cer',], name: 'Pendiente del terreno', },
            { v: 47, c: 47, rtype: ['cer',], name: 'Coincide con foto valla', },
            { v: 48, c: 48, rtype: ['ph',], name: 'Localizacion', },
            { v: 49, c: 49, rtype: ['ph',], name: 'Plantas de todos los pisos', },
            { v: 50, c: 50, rtype: ['ph',], name: 'Linderos del area privada construida', },
            { v: 51, c: 51, rtype: ['ph',], name: 'Linderos del area privada libre', },
            { v: 52, c: 52, rtype: ['ph',], name: 'Nombres de los espacios', },
            { v: 53, c: 53, rtype: ['ph',], name: 'Cuadro de convenciones', },
            { v: 54, c: 54, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], name: 'Piscinas', },
            { v: 55, c: 55, rtype: ['con', 'col',], name: 'Cerramiento (detalle, ml, area, cotas, materiales)' },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_5', rtype: ['con', 'cer', 'col', 'cre',], title: 'Cortes',
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'col', 'cre',], className: 'text-primary', name: 'Relación con el espacio público y privado', },
            { v: 2, c: 2, rtype: ['con', 'sub', 'cer', 'col', 'cre',], className: 'text-primary', name: 'Indicación de la pendiente del terreno', },
            { v: 3, c: 3, rtype: ['con', 'sub', 'cer', 'col', 'cre',], className: 'text-primary', name: 'Niveles por piso', },
            { v: 4, c: 4, rtype: ['con', 'sub', 'cer', 'col', 'cre',], className: 'text-primary', name: 'Cotas totales y parciales', },
            { v: 5, c: 5, rtype: ['con', 'sub', 'cer', 'col', 'cre',], className: 'text-primary', name: 'Ejes estructurales', },
            { v: 6, c: 6, rtype: ['con', 'col',], name: 'Corte longitudinal (min1)', },
            { v: 7, c: 7, rtype: ['con', 'col',], name: 'Corte transversal (min 1)', },
            { v: 8, c: 8, rtype: ['con', 'col',], name: 'Cotas verticales', },
            { v: 9, c: 9, rtype: ['con', 'col',], name: 'Coincide con foto valla', hide: true },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_6', rtype: ['con', 'cer', 'ph', 'col', 'cre',], title: 'Fachadas',
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Indicación de la pendiente el terreno', },
            { v: 2, c: 2, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Niveles por piso', },
            { v: 3, c: 3, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Cotas totales y parciales', },
            { v: 4, c: 4, rtype: ['con', 'col',], name: 'Cotas verticales', },
            { v: 5, c: 5, rtype: ['con', 'col',], name: 'La cantidad de fachadas existentes', },
            { v: 6, c: 6, rtype: ['con', 'col'], name: 'Materiales en fachada', },
            { v: 7, c: 7, rtype: ['con', 'col',], name: 'Ejes estructurales acotados', },
            { v: 8, c: 8, rtype: ['con', 'col',], name: 'Coincide con foto valla', },
            { v: 9, c: 9, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: 'Coincidencia de las fachadas con las plantas', },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_7', rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], title: false,
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Plantas, cortes y fachadas a la misma escala', }
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_8', rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], title: false,
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], className: 'text-primary', name: 'Planos arquitectónicos para el reconocimiento de la existencia de edificaciones', }
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_9', rtype: ['con', 'col',], title: 'Plano de Levantamiento',
        items: [
            { v: 1, c: 1, rtype: ['con', 'col',], name: 'Levantamiento de la construcción', }
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_10', rtype: ['con', 'col',], title: 'Cubierta',
        items: [
            { v: 1, c: 1, rtype: ['con', 'col',], name: 'Coincide la escala con el dibujo', },
            { v: 2, c: 2, rtype: ['con', 'col',], name: 'Cotas', },
            { v: 3, c: 3, rtype: ['con', 'col',], name: 'Materiales en cubierta', },
            { v: 4, c: 4, rtype: ['con', 'col',], name: 'Indicación de cortes', },
            { v: 5, c: 5, rtype: ['con', 'col',], name: 'Inclinación y porcentaje de inclinación', },
            { v: 6, c: 6, rtype: ['con', 'col',], name: 'Ejes estructurales acotados', },
            { v: 7, c: 7, rtype: ['con', 'col',], name: 'Muro de remate o cumbrera', },
            { v: 8, c: 8, rtype: ['con', 'col',], name: 'Espacio para tanques', },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_11', rtype: ['con', 'col', 'cre',], title: 'Cuadro NSR-10',
        items: [
            { v: 1, c: 1, rtype: ['con', 'col', 'cre',], name: 'Grupo de ocupación', },
            { v: 2, c: 2, rtype: ['con', 'col', 'cre',], name: 'Subgrupo de ocupación', },
            { v: 3, c: 3, rtype: ['con', 'col', 'cre',], name: 'Carga de ocupación', },
            { v: 4, c: 4, rtype: ['con', 'col', 'cre',], name: 'Distancia a salidas', },
            { v: 5, c: 5, rtype: ['cre',], name: 'Firma del diseñador de elementos no estructurales según A.1.5.2.2', },
            { v: 6, c: 6, rtype: ['cre',], name: 'Todos los planos arquitectónicos deben incluir una nota visible que contenga el Grupo de Uso según A.2.5 del Reglamento NSR-10 (I, II, III o IV)', },
            { v: 7, c: 7, rtype: ['cre',], name: 'Grado de Desempeño de los elementos no estructurales (Superior, Bueno o Bajo) que se requiere para el grupo de uso de la edificación según A.9.2 del Reglamento NSR-10', },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_12', rtype: ['con', 'sub', 'cer', 'ph', 'col', 'cre',], title: 'Anexos',
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'col', 'cre',], name: 'Planos topográficos', },
            { v: 2, c: 2, rtype: ['con', 'sub', 'cer', 'col', 'cre',], name: 'Planos urbanísticos', },
            { v: 3, c: 3, rtype: ['con', 'cer', 'col', 'cre',], name: 'Plano licencia anterior', },
            { v: 4, c: 4, rtype: ['ph',], name: 'Folio', },
            { v: 5, c: 5, rtype: ['ph',], name: 'Impuesto predial', },
            { v: 6, c: 6, rtype: ['ph',], name: 'Licencia y planos aprobados', },
            { v: 7, c: 7, rtype: ['ph',], name: 'Poder', },
            { v: 8, c: 8, rtype: ['ph',], name: 'Documentos del profesional', },
            { v: 9, c: 9, rtype: ['ph',], name: 'CC del propietario', },
            { v: 10, c: 10, rtype: ['ph',], name: 'Licencia vigente o declaración juramentada de la construcción finalizada', },
            { v: 11, c: 11, rtype: ['ph',], name: 'Formulario diligenciado', },
            { v: 12, c: 12, rtype: ['con', 'sub', 'cer', 'col', 'cre',], name: 'Plano topográfico rural o suburbano con ríos, cauces, canales, servidumbres, vías y redes eléctricas', },
            { v: 13, c: 13, rtype: ['con', 'sub', 'cer', 'col', 'cre',], name: 'Estudio hidrológico con cota de inundación', },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_13', rtype: ['sub', 'cer', 'col',], title: 'Cuadro de Coordenadas',
        items: [
            { v: 1, c: 1, rtype: ['sub', 'cer', 'col',], name: 'Punto', },
            { v: 2, c: 2, rtype: ['sub', 'cer', 'col',], name: 'Latitud y longitud de cada punto', },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_14', rtype: ['sub', 'cer', 'ph', 'col',], title: 'Cuadro de Linderos',
        items: [
            { v: 1, c: 1, rtype: ['sub', 'cer', 'col',], name: 'Inicio de linderos desde el noroccidente', },
            { v: 2, c: 2, rtype: ['sub', 'cer', 'col',], name: 'Tramo', },
            { v: 3, c: 3, rtype: ['sub', 'cer', 'col',], name: 'Punto intermedio', },
            { v: 4, c: 4, rtype: ['sub', 'cer', 'col',], name: 'Tipo de linea', },
            { v: 5, c: 5, rtype: ['sub', 'cer', 'col',], name: 'Sentido', },
            { v: 6, c: 6, rtype: ['sub', 'cer', 'col',], name: 'Distancia', },
            { v: 7, c: 7, rtype: ['sub', 'cer', 'col',], name: 'Predio colindante', },
            { v: 8, c: 8, rtype: ['ph',], name: 'Linderos en sentido de las manecillas del reloj', },
            { v: 9, c: 9, rtype: ['ph',], name: 'Cuadro de linderos ', },
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_15', rtype: ['con', 'sub', 'cer', 'ph', 'col',], title: false,
        items: [
            { v: 1, c: 1, rtype: ['con', 'sub', 'cer', 'ph', 'col',], name: ' Visualización de planos y detalles claros (no borrosos) para verificar su cumplimiento', }
        ]
    },
    {
        v: 0, c: 0, pid: 'rar_16', rtype: ['cre',], title: false,
        items: [
            { v: 1, c: 1, rtype: ['cre',], name: 'Coincide la escala con el dibujo', },
            { v: 2, c: 2, rtype: ['cre',], name: 'Retroceso y/o aislamientos', },
            { v: 3, c: 3, rtype: ['cre',], name: 'Visto bueno de la copropiedad', },
            { v: 4, c: 4, rtype: ['cre',], name: 'Ubicación de la edificación según urbanismo/Reglamento PH', },
            { v: 5, c: 5, rtype: ['cre',], name: 'Area lote', },
            { v: 6, c: 6, rtype: ['cre',], name: 'Área construida por piso', },
            { v: 7, c: 7, rtype: ['cre',], name: 'Cuadro de indices', },
            { v: 8, c: 8, rtype: ['cre',], name: 'Alzados relacionados con el espacio publico y privado', },
            { v: 9, c: 9, rtype: ['cre',], name: 'Planta de cubierta', },
            { v: 10, c: 10, rtype: ['cre',], name: 'Altura máxima', },
            { v: 11, c: 11, rtype: ['cre',], name: 'Planta de todos los niveles', },
            { v: 12, c: 12, rtype: ['cre',], name: 'Iluminación y ventilación de los espacios (obra nueva)', },
            { v: 13, c: 13, rtype: ['cre',], name: 'Voladizo', },
            { v: 14, c: 14, rtype: ['cre',], name: 'Antejardin', },
            { v: 15, c: 15, rtype: ['cre',], name: 'Aislamientos laterales', },
            { v: 16, c: 16, rtype: ['cre',], name: 'Coincidencia con proyecto estructural', },
            { v: 17, c: 17, rtype: ['cre',], name: 'Ruta de evacuación', },
            { v: 18, c: 18, rtype: ['cre',], name: 'Accesibilidad', },
            { v: 19, c: 19, rtype: ['cre',], name: 'Escaleras, ancho, huella, contrahuella, pasamanos y detalle', },
            { v: 20, c: 20, rtype: ['cre',], name: 'Parqueaderos /cupos', },
            { v: 21, c: 21, rtype: ['cre',], name: 'Aislamiento antisismico', },
            { v: 22, c: 22, rtype: ['cre',], name: 'Wc (comerciales 1.80*1.90)', },
            { v: 23, c: 23, rtype: ['cre',], name: 'Planta rociadores (uso distinto a residencial)', },
            { v: 24, c: 24, rtype: ['cre',], name: 'Cerramiento (detalle, ml, area, cotas, materiales)', },
            { v: 25, c: 25, rtype: ['cre',], name: 'Coincide con foto valla', },
            { v: 26, c: 26, rtype: ['cre',], name: 'Coincidencia de las fachadas con las plantas / plantas y fachadas a la misma escala', },
            { v: 27, c: 27, rtype: ['cre',], name: 'Materiales en cubierta', },
            { v: 28, c: 28, rtype: ['cre',], name: 'Plano de Levantamiento', },
            { v: 29, c: 29, rtype: ['cre',], name: 'EDARFRI', },
            { v: 30, c: 30, rtype: ['cre',], name: 'PISCINAS', },
            { v: 31, c: 31, rtype: ['cre',], name: 'NORMA URBANA', },
            { v: 32, c: 32, rtype: ['cre',], name: 'CUADRO NSR10', },
            { v: 33, c: 33, rtype: ['cre',], name: 'Categoria  de riesgo', },
            { v: 34, c: 34, rtype: ['cre',], name: 'Número de salidas requeridas y aplicadas', },
            { v: 35, c: 35, rtype: ['cre',], name: 'Zona de amenaza sismica', },
            { v: 36, c: 36, rtype: ['cre',], name: 'Grado de disipación de energia', },
            { v: 37, c: 37, rtype: ['cre',], name: 'Vecinos', },
            { v: 38, c: 38, rtype: ['cre',], name: 'Accesos al proyecto', },
            { v: 39, c: 39, rtype: ['cre',], name: 'Cotas voladizo', },
            { v: 40, c: 40, rtype: ['cre',], name: 'Área otro uso (local comercial, etc)', },
            { v: 41, c: 41, rtype: ['cre',], name: 'Nombre de unidades', },
            { v: 42, c: 42, rtype: ['cre',], name: 'Información clara y legible', },
        ]
    },
];


export const REVIEW_DOCS_2 = [
    {
        v: 0, c: 0, j: 0, pid: 'rar2_0', rtype: ['con', 'col', 'sub',], title: 'Edificabilidad POT',
        items: [
            { v: 1, c: 1, j: 1, rtype: ['con', 'col',], name: 'Altura máxima en metros', },
            { v: 2, c: 2, j: 2, rtype: ['con', 'col',], name: 'Número de pisos habitables', },
            { v: 3, c: 3, j: 3, rtype: ['con', 'col',], name: 'Sótanos', },
            { v: 4, c: 4, j: 4, rtype: ['con', 'col',], name: 'Semisótanos', },
            { v: 5, c: 5, j: 5, rtype: ['con', 'col',], name: 'Estacionamientos', },
            { v: 6, c: 6, j: 6, rtype: ['con', 'col',], name: 'Antejardin', },
            { v: 7, c: 7, j: 7, rtype: ['con', 'col',], name: 'Voladizos', },
            { v: 8, c: 8, j: 8, rtype: ['con', 'col',], name: 'Aislamiento posterior', },
            { v: 9, c: 9, j: 9, rtype: ['con', 'col',], name: 'Aislamiento lateral', },
            { v: 10, c: 10, j: 10, rtype: ['con', 'col',], name: 'Aislamiento entre edificaciones', },
            { v: 11, c: 11, j: 11, rtype: ['con', 'col',], name: 'Cerramiento', },
            { v: 12, c: 12, j: 12, rtype: ['con', 'col',], name: 'Indice de ocupación', },
            { v: 13, c: 13, j: 13, rtype: ['con', 'col',], name: 'Indice de construcción', },
            { v: 14, c: 14, j: 14, rtype: ['con', 'col', 'sub',], name: 'Cesiones públicas', },
            { v: 15, c: 15, j: 15, rtype: ['con', 'col', 'sub',], name: 'Cesiones privadas', },
        ]
    },
    {
        v: 0, c: 0, j: 0, pid: 'rar2_1', rtype: ['con', 'col'], title: 'Eliminación de barreras arquitectónicas',
        items: [
            { v: 1, c: 1, j: 1, rtype: ['con', 'col',], name: 'Puertas', },
            { v: 2, c: 2, j: 2, rtype: ['con', 'col',], name: 'Rampas', },
            { v: 3, c: 3, j: 3, rtype: ['con', 'col',], name: 'Escaleras', },
            { v: 4, c: 4, j: 4, rtype: ['con', 'col',], name: 'Baños', },
            { v: 5, c: 5, j: 5, rtype: ['con', 'col',], name: 'Pasillos y corredores', },
            { v: 6, c: 6, j: 6, rtype: ['con', 'col',], name: 'Ascensores', },
            { v: 7, c: 7, j: 7, rtype: ['con', 'col',], name: 'Estacionamientos adaptados', },
        ]
    },
]